import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface ApiKey {
    id: string
    name: string
    keyPrefix: string
    createdAt: string
    lastUsedAt: string | null
}

interface ApiKeysState {
    keys: ApiKey[]
    newKey: string | null
    loading: boolean
    error: string | null
}

const initialState: ApiKeysState = {
    keys: [],
    newKey: null,
    loading: false,
    error: null,
}

const apiKeysSlice = createSlice({
    name: 'apiKeys',
    initialState,
    reducers: {
        fetchApiKeysSaga: (_state, _action: PayloadAction<string>) => {},
        createApiKeySaga: (_state, _action: PayloadAction<{ workspaceId: string; name: string }>) => {},
        deleteApiKeySaga: (_state, _action: PayloadAction<{ id: string; workspaceId: string }>) => {},

        setKeys: (state, action: PayloadAction<ApiKey[]>) => {
            state.keys = action.payload
        },
        setNewKey: (state, action: PayloadAction<string | null>) => {
            state.newKey = action.payload
        },
        addKey: (state, action: PayloadAction<ApiKey>) => {
            state.keys.unshift(action.payload)
        },
        removeKey: (state, action: PayloadAction<string>) => {
            state.keys = state.keys.filter(k => k.id !== action.payload)
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload
        },
    },
})

export const {
    fetchApiKeysSaga,
    createApiKeySaga,
    deleteApiKeySaga,
    setKeys,
    setNewKey,
    addKey,
    removeKey,
    setLoading,
    setError,
} = apiKeysSlice.actions

export default apiKeysSlice.reducer
